module.exports = __webpack_public_path__ + "img/scenario_makeup_icon.315adf10.png";